import AddListTable, { AddListTableRow, AddListTableHeader, AddListTableBody, AddListTableItem } from "./AddListTable";
AddListTable.Header = AddListTableHeader;
AddListTable.Body = AddListTableBody;
AddListTable.Row = AddListTableRow;
AddListTable.Item = AddListTableItem;
export default AddListTable;